import { Store } from '@models/store';

export class Config {
	stores: Store[] = [];
}